"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketsViewer = void 0;
const brackets_memory_db_1 = require("brackets-memory-db");
const brackets_manager_1 = require("brackets-manager");
const main_1 = require("./main");
Object.defineProperty(exports, "BracketsViewer", { enumerable: true, get: function () { return main_1.BracketsViewer; } });
window.bracketsViewer = new main_1.BracketsViewer();
window.inMemoryDatabase = new brackets_memory_db_1.InMemoryDatabase();
window.bracketsManager = new brackets_manager_1.BracketsManager(window.inMemoryDatabase);
